<template>
  <div>
    <header id="home">
      <div class="main-menu">
        <div class="navbar-wrapper">
          <div class="navbar navbar-inverse navbar-fixed-top" role="navigation">
            <div class="container">
              <div class="navbar-header">
                <button
                  type="button"
                  class="navbar-toggle"
                  data-toggle="collapse"
                  data-target=".navbar-collapse"
                >
                  <span class="sr-only">Toggle Navigation</span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                </button>
                <a href="#home" class="navbar-brand"
                  ><img
                    src="dist/assets/img/logos/app_logo_hr_01.png"
                    alt="ZOE HEALTH SOLUTIONS Ltd Logo"
                /></a>
              </div>

              <div class="navbar-collapse collapse">
                <ul class="nav navbar-nav navbar-right">
                  <li><a href="#home">Home</a></li>
                  <li><a href="#about">About</a></li>
                  <li><a href="#features">Services</a></li>
                  <li><a href="#testimonials">Our Values</a></li>
                  <li><a href="#faq">Jobs</a></li>
                  <li><a href="#footer">Contact</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="slider">
        <div id="fawesome-carousel" class="carousel slide" data-ride="carousel">
          <ol class="carousel-indicators indicatior2">
            <li
              data-target="#fawesome-carousel"
              data-slide-to="0"
              class="active"
            ></li>
            <li data-target="#fawesome-carousel" data-slide-to="1"></li>
            <li data-target="#fawesome-carousel" data-slide-to="2"></li>
            <li data-target="#fawesome-carousel" data-slide-to="3"></li>
          </ol>
          <div class="carousel-inner" role="listbox">
            <div class="item active">
              <img
                src="dist/assets/img/CareImages/app_banner_001.png"
                alt="ZOE HEALTH SOLUTIONS LTD BANNER 1"
              />
              <div class="carousel-caption">
                <!--<h1 class="wow fadeInLeft item-top">PERSONAL CARE IN THE <br /> COMFORT OF YOUR HOME</h1>-->
                <!--<div class="slider-btn wow fadeIn">
                                    <a href="#features" class="btn btn-learn">More...</a>
                                </div>-->
              </div>
            </div>
            <div class="item">
              <img
                src="dist/assets/img/CareImages/app_healthcare_carer_1002.jpg"
                alt="ZOE HEALTH SOLUTIONS LTD BANNER 2"
              />
              <div class="carousel-caption">
                <h1 class="wow fadeInLeft item-top">
                  PERSONAL CARE IN THE <br />
                  COMFORT OF YOUR HOME
                </h1>
                <div class="slider-btn wow fadeIn">
                  <a href="#features" class="btn btn-learn">More...</a>
                </div>
              </div>
            </div>
            <div class="item">
              <img
                src="dist/assets/img/CareImages/app_health_ltd_banner_008.png"
                alt="ZOE HEALTH SOLUTIONS LTD BANNER 3"
              />
              <div class="carousel-caption">
                <h1 class="wow fadeInLeft item-top">LIVE-IN CARE</h1>
                <div class="slider-btn wow fadeIn">
                  <a href="#features" class="btn btn-learn">More...</a>
                </div>
              </div>
            </div>
            <div class="item">
              <img
                src="dist/assets/img/CareImages/app_healthcare_carer_1022.jpg"
                alt="ZOE HEALTH SOLUTIONS LTD BANNER 5"
              />
              <div class="carousel-caption">
                <h1 class="wow fadeInLeft item-top">
                  CALL US NOW ON:<br />
                  0753 489 4711
                </h1>
                <h3 class="wow fadeInLeft">
                  E-MAIL: office@ZoeHealthSolutions.com
                </h3>
                <div class="slider-btn wow fadeIn">
                  <a href="#features" class="btn btn-learn">More...</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <section id="about" class="site-padding-about">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="about-image wow fadeInLeft">
              <img
                src="dist/assets/img/CareImages/app_health_ltd_carer_001.jpg"
                alt="ABOUT ZOE HEALTH SOLUTIONS IMAGE"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="about-text wow fadeInRight">
              <h3>
                <span style="color: #e20707">ZOE</span>
                <span style="color: #0a1f3f; padding-left: 8px"
                  >HEALTH SOLUTIONS LTD</span
                >
              </h3>
              <p>
                Zoe Health Solutions Ltd is a specialist Healthcare Solutions
                company registered with the Care Quality Commission (CQC).
              </p>
              <p>
                We specialise in providing quality personal care to adults and
                young people above the age of 18.
              </p>
              <p>
                All our operations are underpinned by trust, integrity and a
                commitment to a partnership with service users and stakeholders.
              </p>
              <p>Our services are transparent, ethical and innovative.</p>
              <p>
                Our experienced staff are dedicated to deliver quality care in a
                professional manner.
              </p>
              <p>
                Our clients include private, public and third sector
                organisations.
              </p>
              <p>
                <b>WE COVER THE FOLLOWING AREAS AND BEYOND</b>
              </p>
              <p>
                <b>West Midlands:</b> BIRMINGHAM, DUDLEY, WOLVERHAMPTON,
                WALSALL, WARWICK AND STAFFORD
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <section id="cqc">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="title2">
              <h3><span>CQC overview and inspections</span></h3>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <script2
              type="text/javascript"
              src="https://www.cqc.org.uk/sites/all/modules/custom/cqc_widget/widget.js?data-id=1-5745520271&data-host=www.cqc.org.uk&type=location"
            ></script2>
          </div>
        </div>
      </div>
    </section> -->

    <section id="features" class="site-padding">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="title">
              <h3>
                <span style="color: #00bfff">Our </span
                ><span style="color: #0a1f3f">Services</span>
              </h3>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <p style="margin-bottom: 40px">
              We strive to provide our clients with the highest and most
              reliable level of support available. We provide care to meet a
              comprehensive range of client needs in order to help adults stay
              independent and live in their own homes or supported living
              schemes.
            </p>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="single-feature wow fadeInLeft">
              <div class="row">
                <div class="col-md-1">
                  <div class="feature-icon">
                    <i class="fa fa-home"></i>
                  </div>
                </div>
                <div class="col-md-11">
                  <div class="feature-text">
                    <h4>Supported Living - Disability</h4>
                    <p>
                      Our flexible and varied range of services providing
                      disability support include: supported housing, (we source
                      accomodation for you) supported housing with care, respite
                      care and residential homes. Support time can vary from a
                      few hours a week, up to full-time support or intensive
                      support ove r a short period of time to help achieve a
                      goal.
                    </p>
                    <p>
                      We provide expert tailored support and care for people
                      aged 18 or over with mild, moderate or severe
                      disabilities, including:
                    </p>

                    <ul class="fa-ul">
                      <li><i class="fa-li fa fa-check-square"></i>Autism</li>
                      <li>
                        <i class="fa-li fa fa-check-square"></i>Sensory
                        disabilities
                      </li>
                      <li>
                        <i class="fa-li fa fa-check-square"></i>Physical
                        disabilities
                      </li>
                      <li>
                        <i class="fa-li fa fa-check-square"></i>Acquired brain
                        injury
                      </li>
                      <li>
                        <i class="fa-li fa fa-check-square"></i>Associated
                        mental health needs
                      </li>
                      <li>
                        <i class="fa-li fa fa-check-square"></i>Behavioural
                        challenges
                      </li>
                      <li>
                        <i class="fa-li fa fa-check-square"></i>Support and care
                        is tailored to individual needs
                      </li>
                    </ul>
                    <p>
                      If you're looking for supported living whilst living an
                      independent life, you've come to the right place. We are
                      passionate about delivering the best possible care and
                      support.
                    </p>
                    <p>
                      Supported living allows you to live independently and have
                      control over how and when you receive support. We can
                      support you to achieve your goals, such as becoming an
                      active member of your local community.
                    </p>
                    <p>
                      Our flexible support is tailored to your needs, whether
                      you're looking for a few hours a week or more. Together,
                      we co-create personalised support plans focusing on your
                      interests, priorities and skills.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-sm-4">
            <div class="single-feature wow fadeInLeft">
              <div class="row">
                <div class="col-md-2">
                  <div class="feature-icon">
                    <i class="fa fa-bitbucket"></i>
                  </div>
                </div>
                <div class="col-md-10">
                  <div class="feature-text">
                    <h4>Domestic Care</h4>
                    <p>
                      We provide domestic support at all levels from emptying a
                      bin and replacing a light bulb to cleaning a home and
                      completing all laundry requirements. Our professional
                      staff have been trained to maintain high standards of
                      hygiene and cleanliness to ensure our clients wellbeing
                      and good health is maintained. We're more than happy to
                      help with the following:
                    </p>
                    <ul class="fa-ul">
                      <li>
                        <i class="fa-li fa fa-check-square"></i>Food and drink
                        preparation
                      </li>
                      <li>
                        <i class="fa-li fa fa-check-square"></i>Food shopping
                      </li>
                      <li>
                        <i class="fa-li fa fa-check-square"></i>Cleaning and
                        tidying up
                      </li>
                      <li>
                        <i class="fa-li fa fa-check-square"></i>Washing up
                      </li>
                      <li>
                        <i class="fa-li fa fa-check-square"></i>Laundry and
                        ironing
                      </li>
                      <li><i class="fa-li fa fa-check-square"></i>Vacuuming</li>
                      <li>
                        <i class="fa-li fa fa-check-square"></i>Other light
                        household duties
                      </li>
                    </ul>
                    <p>
                      Whether you or your family member require help every day
                      or once a week, help with the household chores can provide
                      great relief, especially for people who may suffer from
                      mobility around the home.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="single-feature wow fadeInLeft">
              <div class="row">
                <div class="col-md-2">
                  <div class="feature-icon">
                    <i class="fa fa-user-circle"></i>
                  </div>
                </div>
                <div class="col-md-10">
                  <div class="feature-text">
                    <h4>Personal Care</h4>
                    <p>
                      Our professional and caring staff are able to provide a
                      wide range of personal care services allowing our clients
                      to maintain their dignity and respect. Our services
                      include:
                    </p>
                    <ul class="fa-ul">
                      <li>
                        <i class="fa-li fa fa-check-square"></i
                        ><b>Assisting clients with their personal hygiene</b>
                        Personal care is a regulated activity, which means any
                        aspect of personal care services are required to be
                        registered and are inspected and rated. Personal care
                        consists of any aspect or any level of personal hygiene
                        i.e. washing, bathing, continence care etc.
                      </li>
                      <li>
                        <i class="fa-li fa fa-check-square"></i
                        ><b>Assistance with dressing</b>
                        This includes helping clients to get dressed, choosing
                        appropriate clothing or to give full support in dressing
                        or just helping with socks or surgical stockings.
                      </li>
                      <li>
                        <i class="fa-li fa fa-check-square"></i
                        ><b>Support with medication</b>
                        We can support with full administration of medication,
                        prompting (or reminding) medication where appropriate
                        and safe to do. We can also support with collection and
                        ordering of prescribed medication. We can provide the
                        support you need even if you just require support to
                        open medication.
                      </li>
                      <li>
                        <i class="fa-li fa fa-check-square"></i
                        ><b>Assistance with meals</b>
                        We can support with preparing foods at any level.
                        Support with helping to eat can also be included.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="single-feature wow fadeInRight">
              <div class="row">
                <div class="col-md-2">
                  <div class="feature-icon">
                    <i class="fa fa-wheelchair-alt"></i>
                  </div>
                </div>
                <div class="col-md-10">
                  <div class="feature-text">
                    <h4>Physical Disabilities Care</h4>
                    <p>
                      Just because you may have a physical disability does not
                      mean you can't enjoy a full and active life living in your
                      own home. Our professional carers will listen to your
                      needs and put together a bespoke support package to meet
                      your requirements. This can range from once a week visits
                      to daily visits or even live in care. We can help you with
                      a wide range of tasks including domestic duties around the
                      home, personal care and washing, social appointments and
                      hobbies. Indeed, our support packages are aimed at helping
                      you stay independent in the comfort of your own home,
                      allowing you to maintain your everyday routine.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="single-feature wow fadeInLeft">
              <div class="row">
                <div class="col-md-2">
                  <div class="feature-icon">
                    <i class="fa fa-coffee"></i>
                  </div>
                </div>
                <div class="col-md-10">
                  <div class="feature-text">
                    <h4>Respite Care</h4>
                    <p>
                      Our respite care is available to any family member or
                      friend that has become a carer. We acknowledge the vital
                      role they play in people's lives and will support them by
                      offering time off and looking after their loved ones, in
                      the way they do. This could be anything from an afternoon,
                      a day or a month at a time.
                    </p>
                    <p>
                      It's important that you make time for yourself, both for
                      your own wellbeing and health but also to revitalise
                      yourself to carry on caring for your loved one. We
                      appreciate that speaking up and asking for some help is a
                      hard thing to do for many people, but we have helped many
                      family carers by giving them a break and have seen
                      first-hand the positive effect it has had on both their
                      own lives and that of the person they've been caring for.
                    </p>
                    <p>
                      Contact our office and we will answer any questions that
                      you may have about receiving respite care and how it all
                      works.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="single-feature wow fadeInLeft">
              <div class="row">
                <div class="col-md-2">
                  <div class="feature-icon">
                    <i class="fa fa-smile-o"></i>
                  </div>
                </div>
                <div class="col-md-10">
                  <div class="feature-text">
                    <h4>Social Care</h4>
                    <p>
                      We actively promote social care and encourage socialising
                      in any appropriate form. We can escort and remain with you
                      to participate in any clubs, groups, days centres or
                      colleges. We fully believe that social interaction is
                      paramount in the care and development and rehabilitation
                      of our clients. If it's basic shopping right through to an
                      activity centre, we will provide the right level of
                      support you require.
                    </p>
                    <p>
                      With <b>ZOE HEALTH SOLUTIONS</b> there is no need to feel
                      isolated anymore. Our carers thoroughly enjoy getting to
                      know our clients and forming strong relationships with
                      them. We'll help build their confidence and allow them to
                      feel comfortable in every day social situations.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="single-feature wow fadeInRight">
              <div class="row">
                <div class="col-md-2">
                  <div class="feature-icon">
                    <i class="fa fa-home"></i>
                  </div>
                </div>
                <div class="col-md-10">
                  <div class="feature-text">
                    <h4>24/7 Live-in Care</h4>
                    <p>
                      Our live-in care package gives your loved ones fulltime
                      support and care in the comfort of their own home by
                      matching your loved one with a dedicated care professional
                      who moves into their home.
                    </p>
                    <p>
                      <b>ZOE HEALTH SOLUTIONS</b> provides experienced, vetted
                      carers that help with everything from personal hygiene to
                      daily household tasks, ensuring your relative is safe and
                      happy in place they love most, their own home.
                    </p>
                    <p>
                      We understand your loved one's safety is paramount. That's
                      why we go to great lengths to ensure their carer is
                      someone the whole family can trust. All the professionals
                      we work with have background checks, referencing and
                      certificates to prove they reach the standards you expect.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="testimonials">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="title">
              <h3>Our Values &amp; Principles</h3>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="carouselButtons">
              <button
                id="playValues"
                type="button"
                class="btn btn-default btn-xs"
              >
                <span class="fa fa-play-circle-o"></span>
              </button>
              <button
                id="pauseValues"
                type="button"
                class="btn btn-default btn-xs"
              >
                <span class="fa fa-pause-circle-o"></span>
              </button>
            </div>
          </div>
        </div>
        <div
          id="fawesome-carousel-two"
          class="carousel slide"
          data-ride="carousel"
        >
          <ol class="carousel-indicators">
            <li
              data-target="#fawesome-carousel-two"
              data-slide-to="0"
              class="active"
            ></li>
            <li data-target="#fawesome-carousel-two" data-slide-to="1"></li>
            <li data-target="#fawesome-carousel-two" data-slide-to="2"></li>
            <li data-target="#fawesome-carousel-two" data-slide-to="3"></li>
          </ol>

          <div class="carousel-inner" role="listbox">
            <div class="item active">
              <div class="row">
                <div class="col-sm-6">
                  <div class="single-testimonials">
                    <div class="text">
                      <p>
                        <b>Privacy</b>
                        The right of individuals to be left alone or undisturbed
                        and free from intrusion into their affairs. This is
                        taken into account in the formulation of Care Plans, and
                        will only be overridden in exceptional circumstances,
                        and with the knowledge of the service user or their
                        advocate.
                      </p>
                    </div>

                    <div class="profile-image">
                      <span class="fa fa-thumbs-o-up"></span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="single-testimonials">
                    <div class="text">
                      <p>
                        <b>Confidentiality</b>
                        Service user confidentiality is, wherever possible,
                        maintained. On occasion, it will be necessary, for the
                        benefit of the service user or others to share personal
                        information with either other professionals or
                        organisations. Where possible, service users are
                        consulted and their views taken into account.
                      </p>
                    </div>

                    <div class="profile-image">
                      <span class="fa fa-thumbs-o-up"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Slide 2 -->
            <div class="item">
              <div class="row">
                <div class="col-sm-6">
                  <div class="single-testimonials">
                    <div class="text">
                      <p>
                        <b>Dignity</b>
                        All individuals, whatever their circumstances, have the
                        right to be treated with dignity and respect.
                      </p>
                      <p>
                        <b>Choice</b>
                        Services are designed to be accessible and flexible,
                        promoting ordinary lifestyles and based upon client's
                        own choices. Individual choice is promoted, within the
                        limits imposed by service constraints.
                      </p>
                    </div>

                    <div class="profile-image">
                      <span class="fa fa-thumbs-o-up"></span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="single-testimonials">
                    <div class="text">
                      <p>
                        <b>Anti-discrimination</b>
                        Many clients, because of their circumstances, (e.g. age,
                        disability, gender, marital status, sexual orientation,
                        culture, religion or nationality), may find themselves
                        in circumstances in which discrimination can occur. NSF
                        HEALTH designs its services and delivery to, wherever
                        possible, promote equality and counteract discrimination
                        where it arises.
                      </p>
                    </div>

                    <div class="profile-image">
                      <span class="fa fa-thumbs-o-up"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Next Slide -->
            <!-- Slide 3 -->
            <div class="item">
              <div class="row">
                <div class="col-sm-6">
                  <div class="single-testimonials">
                    <div class="text">
                      <p>
                        <b>Communication</b>
                        Many clients, because of their circumstances, (e.g. age,
                        disability, gender, marital status, sexual orientation,
                        culture, religion or nationality), may find themselves
                        in circumstances in which discrimination can occur. NSF
                        HEALTH designs its services and delivery to, wherever
                        possible, promote equality and counteract discrimination
                        where it arises.
                      </p>
                    </div>

                    <div class="profile-image">
                      <span class="fa fa-thumbs-o-up"></span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="single-testimonials">
                    <div class="text">
                      <p>
                        <b>Independence</b>
                        Clients are enabled to act independently. Services are
                        aimed at maximising the individual's capacity for
                        self-care and mobility. Every individual, whatever their
                        circumstances, has the potential for development, and
                        the right to hold personal aspirations. Within the
                        boundaries set by legislation and professional social
                        work ethics, service users are encouraged in achieving
                        their personal goals.
                      </p>
                    </div>

                    <div class="profile-image">
                      <span class="fa fa-thumbs-o-up"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Slide 4 -->
            <div class="item">
              <div class="row">
                <div class="col-sm-6">
                  <div class="single-testimonials">
                    <div class="text">
                      <p>
                        <b>Rights</b>
                        The rights of citizenship are safeguarded for all
                        service users. Work should be conducted in a manner that
                        facilitates empowerment and makes appropriate use of
                        advocacy.
                      </p>
                      <p>
                        <b>Responsibilities</b>
                        Clients are expected to accept appropriate
                        responsibilities, taking into account their particular
                        abilities and circumstances. These may include having
                        due regard for others, for property or for participation
                        in Care Plans.
                      </p>
                    </div>

                    <div class="profile-image">
                      <span class="fa fa-thumbs-o-up"></span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="single-testimonials">
                    <div class="text">
                      <p>
                        <b>Family Support</b>
                        The value of the contribution of client's family support
                        is fully recognised. The needs of the client we are
                        providing, or intending to provide, regular or
                        substantial care is, where requested, assessed
                        independently of the needs of the client. The outcome of
                        the assessment is taken into account when agreeing Care
                        Plans.
                      </p>
                    </div>

                    <div class="profile-image">
                      <span class="fa fa-thumbs-o-up"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="faq">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="title">
              <h3><span>Jobs</span></h3>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="panel-group" id="accordion">
              <div class="faqHeader">
                <h2>Care Assistants and Support Workers - Job Application</h2>
              </div>

              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h3 class="panel-title">
                    <a
                      class="accordion-toggle"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      href="#collapseOne"
                      >APPLY ONLINE</a
                    >
                  </h3>
                </div>
                <div id="collapseOne" class="panel-collapse collapse">
                  <div class="panel-body">
                    <p class="stam-application-info">
                      Complete the application form below and make sure all
                      questions marked as required are filled-in.<br />
                      A copy of the completed online application form will be
                      sent to your e-mail address, so please check that your
                      e-mail address is correct.<br />
                      Click the submit button when you have finished completing
                      the form.<br />
                      We will review your application and contact you within
                      three working days.
                    </p>
                    <application-form></application-form>
                  </div>
                </div>
              </div>

              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h3 class="panel-title">
                    <a
                      class="accordion-toggle collapsed"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      href="#collapseTwo"
                      >DOWNLOAD APPLICATION PACK</a
                    >
                  </h3>
                </div>
                <div id="collapseTwo" class="panel-collapse collapse in">
                  <div class="panel-body">
                    <div class="col-sm-4">
                      <p>
                        To apply for this job, you may download and complete the
                        application pack and e-mail to
                        <span style="color: #0094ff"
                          >office@ZoeHealthSolutions.com</span
                        >
                        or post to the address detailed below.
                      </p>
                    </div>
                    <div
                      class="col-sm-8 wow rollIn center"
                      data-wow-duration="1s"
                      data-wow-delay="1s"
                    >
                      <div class="file-download-app-pack">
                        <div class="file-download-app-pack-title">
                          Application pack
                        </div>
                        <span
                          class="file-download-app-pack-span fa fa-file-pdf-o"
                        ></span
                        ><br />
                        <a
                          href="home/download?filename=ZOE_HEALTH_SOLUTIONS_LTD_ApplicationPack.docx"
                          class="file-download-app-pack-btn btn btn-primary btn-lg"
                          ><span
                            class="fa fa-cloud-download file-download-app-pack-btn-logo"
                            role="button"
                          ></span
                          ><span class="file-download-app-pack-btn-text"
                            >Download</span
                          ></a
                        >
                      </div>
                    </div>

                    <!-- <div
                      class="col-sm-4 wow rollIn center"
                      data-wow-duration="1s"
                      data-wow-delay="1s"
                    >
                      <div class="file-download-app-pack">
                        <div class="file-download-app-pack-title">
                          Employer reference
                        </div>
                        <span
                          class="file-download-app-pack-span fa fa-file-pdf-o"
                        ></span
                        ><br />
                        <a
                          href="home/download?filename=app_HEALTH_LTD_EmployerReference_v1.docx"
                          class="file-download-app-pack-btn btn btn-primary btn-lg"
                          ><span
                            class="fa fa-cloud-download file-download-app-pack-btn-logo"
                            role="button"
                          ></span
                          ><span class="file-download-app-pack-btn-text"
                            >Download</span
                          ></a
                        >
                      </div>
                    </div>
 -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="contact-us">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="title">
              <h3>
                <span style="color: #00bfff">Our </span
                ><span style="color: #0a1f3f">Wolverhampton office</span>
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div
        class="googlemap"
        data-latlng="52.567879,-2.152382"
        data-scrollwheel="false"
        data-icon="dist/assets/img/map_marker.png"
        data-zoom="17"
        data-theme="Default"
      >
        <div class="marker-content">
          <h5>ZOE HEALTH SOLUTIONS LTD</h5>
          <p>
            106 Wynn Road<br />
            WV4 4AN<br />
            Penn<br />
            Wolverhampton<br />
            United Kingdom<br />
          </p>
        </div>
      </div>
      <div class="contact">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <contact></contact>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer id="footer">
      <div class="container">
        <div class="row">
          <div class="col-sm-4">
            <div class="single-footer">
              <div class="footer-logo">
                <img
                  src="dist/assets/img/logos/app_logo_main_01.png"
                  alt="ZOE HEALTH SOLUTIONS FOOTER LOGO"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="single-footer">
              <h4>Contact us</h4>
              <p>
                106 Wynn Road<br />
                WV4 4AN<br />
                Penn<br />
                Wolverhampton<br />
                United Kingdom<br />
              </p>
              <p>E-mail: office@ZoeHealthSolutions.com<br /></p>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="single-footer">
              <h4>Opening times</h4>
              <p>
                Mon - Fri:<br />
                09:00am - 17:00pm<br />
                Sat: Closed<br />
                Sun: Closed<br />
                Main contact: <br />
                0753 489 4711
              </p>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="single-footer">
              <h4>Services</h4>
              <ul>
                <li><a href="#features">DOMESTIC CARE</a></li>
                <li><a href="#features">PERSONAL CARE</a></li>
                <li><a href="#features">PHYSICAL DISABILITIES CARE</a></li>
                <li><a href="#features">RESPITE CARE</a></li>
                <li><a href="#features">LIVE-IN CARE</a></li>
                <li><a href="#features">SUPPORT FOR YOUNGER PEOPLE</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>

    <div class="copyright">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="copy-text">
              <p>
                For your software needs contact
                <span style="color: #0094ff">programmer@softmighty.com</span> :
                Business-IT-support, mobile-apps, web-apps, websites,
                data-driven apps, consultancy, and IT Strategy advisory
                services.
              </p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="footer-menu pull-right">
              <ul>
                <li><a href="#home">Home</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#features">Services</a></li>
                <li><a href="#faq">Jobs</a></li>
              </ul>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="social">
              <ul>
                <li>
                  <a href="#" target="_blank"><i class="fa fa-facebook"></i></a>
                </li>
                <li>
                  <a href="#"><i class="fa fa-twitter"></i></a>
                </li>
                <li>
                  <a
                    style="color: #ffffff"
                    href="https://mail5016.site4now.net"
                    target="_blank"
                    >Staff E-mails</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <script2
      src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDQK_5EIUpJzdD7TAq8Has6oNrQpzQAmn8&callback=initMap"
    ></script2>
  </div>
</template>
<script>
import ApplicationForm from "./components/ApplicationForm.vue";
export default {
  components: { ApplicationForm },
  name: "App",
  data() {
    return {};
  },
  methods: {},
  computed: {},
  //   mounted() {
  //       window.wow.init();
  //   }
};
</script>
